import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import img from "@/assets/convenzioni-mani.jpg";
import { HandHeart } from "lucide-react";

const Convenzioni = () => (
  <>
    <SEO
      title="Convenzioni e Servizi — FIABA ETS"
      description="FIABA sviluppa convenzioni con organizzazioni e professionisti qualificati per offrire servizi agevolati e di qualità ai propri associati."
      path="/convenzioni"
    />
    <PageHero
      eyebrow="Convenzioni & Servizi"
      title="Servizi essenziali, accessibili a tutti"
      subtitle="Perché una barriera può essere anche una lista d'attesa o un servizio fuori portata."
    />
    <section className="section-padding">
      <div className="container-narrow grid lg:grid-cols-2 gap-12 items-center">
        <img src={img} alt="Mano di un neonato che stringe il dito di un adulto" className="rounded-lg shadow-elegant" loading="lazy" />
        <div className="space-y-5 text-foreground/90 leading-relaxed">
          <HandHeart className="w-10 h-10 text-secondary" />
          <p>La domanda da cui siamo partiti è: <strong>che cos'è una barriera?</strong></p>
          <p>Una barriera può essere una lista d'attesa, la difficoltà di accedere con semplicità a servizi essenziali e a costi sostenibili, oppure l'impossibilità di ottenere un servizio professionale o un trasporto qualificato per persone con disabilità.</p>
          <p>Per rispondere concretamente a queste esigenze, FIABA sta sviluppando <strong>convenzioni con le principali organizzazioni e con professionisti qualificati</strong>, al fine di offrire servizi agevolati e di qualità a beneficio dei propri associati.</p>
        </div>
      </div>
    </section>
  </>
);

export default Convenzioni;
